const MenuThemes = {
  Default: "default",
  Options: "options",
  Small: "small",
  Mega: "mega",
  Medium: "medium", //225px
  Large: "large",
} as const;

export type MenuTheme = (typeof MenuThemes)[keyof typeof MenuThemes];

export default MenuThemes;
